
import { wialonApi } from '../../environment';
import createSections from './sections';
import RequestsController from './requests';
import type { WialonSections } from './sections';

class WialonApi {
  controller: RequestsController;
  sections: WialonSections;

  constructor(accessToken: string | null) {
    this.controller = new RequestsController(
      wialonApi,
      accessToken
    );
    this.sections = createSections(this.controller);
  }

  async login() {
    await this.controller.login();
  }

  async logout() {
    await this.controller.logout();
  }

  async destroy() {
    await this.controller.destroy();
  }
}

let instance: WialonApi | null = null;

export default (accessToken: string) => {
  if (!accessToken) {
    throw new Error('Wialon access token is required');
  }

  if (instance) {
    if (instance.controller.accessToken !== accessToken) {
      throw new Error('Wialon client belongs to another session');
    }

    return instance;
  }

  instance = new WialonApi(accessToken);
  return instance;
};

export const resetWialonApi = async () => {
  const current = instance;
  instance = null;
  await current?.destroy();
};
